import { FC, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ReactComponent as BurgerSvg } from "images/burger.svg";
import { ReactComponent as IconOne } from "images/documentMenu/icon-1.svg";
import { ReactComponent as IconTwo } from "images/documentMenu/icon-2.svg";
import { ReactComponent as IconTwree } from "images/documentMenu/icon-3.svg";
import cn from "classnames";
import styles from "./Menu.module.sass";

const Menu: FC = () => {
	const { documentId, organizationId, objId } = useParams();

	const state: any = useLocation().state;

	const [isOpen, setIsOpen] = useState<boolean>(true);

	return (
		<div className={cn(styles.menu, { [styles.hidden]: !isOpen })}>
			<button className={styles.burger} onClick={() => setIsOpen((prevState) => !prevState)}>
				<BurgerSvg className={styles.burgerIcon} />
				{isOpen && <span>Меню</span>}
			</button>
			<div className={styles.nav}>
				<Link
					className={cn(styles.link, state.docsId && Number(documentId) === state?.docsId.actId && styles.activeOne)}
					state={{ docsId: { ...state?.docsId } }}
					replace={true}
					to={`/categorization/documents/${organizationId}/${objId}/${state?.docsId.actId}`}>
					<IconOne
						className={cn(styles.icon, styles.red, {
							[styles.fix]: !isOpen,
							[styles.fixOpen]: isOpen,
						})}
					/>
					{isOpen && <span>Просмотр проекта акта категорирования</span>}
				</Link>

				<Link className={styles.link} to={`/categorization/newModel/${organizationId}/${objId}`} state={{ ...state }}>
					<IconTwo className={styles.icon} />
					{isOpen && <span>Повторно пройти процесс подбора категории</span>}
				</Link>

				<Link
					className={cn(styles.link, state.docsId && Number(documentId) === state?.docsId.resId && styles.activeTwo)}
					state={{ docsId: { ...state?.docsId } }}
					replace={true}
					to={`/categorization/documents/${organizationId}/${objId}/${state?.docsId.resId}`}>
					<IconTwree className={styles.icon} />
					{isOpen && <span>Просмотр проекта сведений об объекте</span>}
				</Link>
			</div>
		</div>
	);
};

export default Menu;
